<template>

</template>

<script>
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';
import scrollToError from "@/mixin/scrollToError.vue";

export default {
  components: {
    MaskInput
  },
  mixins: [scrollToError],
  methods: {

  },
  data: () => ({

  }),
}
</script>
